@if (props.template) {
  <div
    class="form-template {{ props.cssClass }}"
    [class.text-end]="props.textRight"
    [innerHtml]="props.template"
    (click)="onClick($event)"
  ></div>
}
